import { Card, Typography } from '@mui/material';
import styled from 'styled-components';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import Shipping from '@/components/result/shipping';
import RouteMap from '@/components/result/routeMap';
import { Floating } from '@/components/result/floating';

const MainWrap = styled(Card)`
  width: 100%;
  height: 100%;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  .head{
    padding: 0.5rem;
    width: 100%;
    height: 2.5rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background:rgba(82, 133, 164, 0.87);
    color: #ffffff;
  }
  .body{
    margin:0;
    padding:0;
    position:relative;
    width:100%;
    height:100%;
    flex-grow:1;
  }
`;

export default function ShippingTemplate({ title, onClick }: { title: string; onClick?: any }) {
  return (
    <MainWrap>
      <div className="head">
        <Typography variant="h6">{title}</Typography>
        {onClick && <FullscreenIcon onClick={onClick} />}
      </div>
      <div className="body">
        <Shipping />
        <RouteMap />
        <Floating />
      </div>
    </MainWrap>
  );
}
